"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfValuationEstimateDto = instanceOfValuationEstimateDto;
exports.ValuationEstimateDtoFromJSON = ValuationEstimateDtoFromJSON;
exports.ValuationEstimateDtoFromJSONTyped = ValuationEstimateDtoFromJSONTyped;
exports.ValuationEstimateDtoToJSON = ValuationEstimateDtoToJSON;
exports.ValuationEstimateDtoToJSONTyped = ValuationEstimateDtoToJSONTyped;
/**
 * Check if a given object implements the ValuationEstimateDto interface.
 */
function instanceOfValuationEstimateDto(value) {
    if (!('lowerPrice' in value) || value['lowerPrice'] === undefined)
        return false;
    if (!('midPrice' in value) || value['midPrice'] === undefined)
        return false;
    if (!('upperPrice' in value) || value['upperPrice'] === undefined)
        return false;
    return true;
}
function ValuationEstimateDtoFromJSON(json) {
    return ValuationEstimateDtoFromJSONTyped(json, false);
}
function ValuationEstimateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lowerPrice': json['lowerPrice'],
        'midPrice': json['midPrice'],
        'upperPrice': json['upperPrice'],
    };
}
function ValuationEstimateDtoToJSON(json) {
    return ValuationEstimateDtoToJSONTyped(json, false);
}
function ValuationEstimateDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'lowerPrice': value['lowerPrice'],
        'midPrice': value['midPrice'],
        'upperPrice': value['upperPrice'],
    };
}
